import gql from 'graphql-tag';

export default gql`
	mutation CreditCardDefault($cardId: ID!) {
		creditCardDefault(card_default: $cardId) {
			succeed
		}
	}
`;
